module.exports = __webpack_public_path__ + "img/level3addon_idle_shadow.233fdea4.png";